import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Input, Icon, Button } from 'antd';
import search from '../../Images/Icons/search.svg';
import TableView from '../../Components/Table';
import ModelActiveComponent from '../ModelList/Components/ModelActiveComponent';
import { fetchArchiveModels, modelUnarchive } from './ModelArchive.saga';
import { storeModelDetails } from '../Login/Login.reducer';
import 'antd/dist/antd.css';
import './ModelArchive.css';
import styles from './ModelArchive.module.css';

const modelColumns = {
  image: {
    title: 'IMAGE',
    key: 'fileContent',
    dataIndex: 'fileContent',
    width: '50px',
    order: 0,
  },
  name: {
    title: 'MODEL NAME',
    key: 'modelName',
    dataIndex: 'modelName',
    width: '150px',
    order: 0,
  },
  type: {
    title: 'MODEL LEARNING MODE',
    dataIndex: 'modelType',
    key: 'modelType',
    width: '130px',
    order: 2,
  },
  actions: {
    title: '',
    dataIndex: 'actions',
    key: 'actions',
    width: '50px',
    dropDownList: {
      edit: 'Edit',
      delete: 'Delete',
      clone: 'Clone',
      archive: 'Archive',
    },
    order: 10,
  },
  emptyCells: {
    title: '',
    dataIndex: 'emptyCells',
    key: 'emptyCells',
    width: '20px',
    order: 15,
  },
};

class ModelArchive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modelActiveRecord: {},
      modelParams: {
        offset: 0,
        size: 7,
        searchValue: '',
        sortBy: '',
        sortDirection: '',
      },
      clientHeight: '',
      importPopup: false,
      deletePopup: false,
      model: {},
    };
  }

  componentDidMount() {
    this.props.fetchArchiveModels({
      params: this.state.modelParams,
      callback: (activeRecord) => {
        this.setState({
          modelActiveRecord: activeRecord,
        });
      },
    });
    // const { history, userDetails } = this.props;
    // if (userDetails && userDetails.roleName === "Operator") {
    //	 history.push("/workspace");
    // }
    // if (userDetails && userDetails.roleName && userDetails.roleName !== "Operator") {
    //	 this.props.fetchModels({
    //		 params: this.state.modelParams,
    //		 callback: (activeRecord) => {
    //			 this.setState({
    //				 modelActiveRecord: activeRecord
    //			 });
    //		 }
    //	 });
    // }
  }

  // componentWillReceiveProps(nextProps) {
  //	 const { history, userDetails } = this.props;
  //	 if (JSON.stringify(userDetails) !== JSON.stringify(nextProps.userDetails) && nextProps.userDetails) {
  //		 if (nextProps && nextProps.userDetails && nextProps.userDetails.roleName === "Operator") {
  //			history.push("/workspace");
  //		 }
  //		 if (nextProps && nextProps.userDetails && nextProps.userDetails.roleName && nextProps.userDetails.roleName !== "Operator") {
  //			this.props.fetchModelRepositoryList({
  //				params: this.state.modelParams,
  //				callback: (activeRecord) => {
  //					this.setState({
  //						modelActiveRecord: activeRecord
  //					 });
  //				 }
  //			 });
  //		 }
  //	 }
  // }
  unArchiveModel = (modelId) => {
    this.props.modelUnarchive(modelId);
  };

  handlePageChange = (offset, sortBy, sortDirection) => {
    this.setState(
      {
        modelParams: {
          ...this.state.modelParams,
          offset,
          sortBy,
          sortDirection,
        },
      },
      () => {
        this.props.fetchModels({
          params: this.state.modelParams,
          callback: (activeRecord) => {
            this.setState({
              modelActiveRecord: activeRecord,
            });
          },
        });
      }
    );
  };

  handleSearch = (event) => {
    this.setState(
      {
        modelParams: {
          ...this.state.modelParams,
          offset: 0,
          searchValue: event.target.value,
        },
      },
      () => {
        this.props.fetchModels({
          params: this.state.modelParams,
          callback: (activeRecord) => {
            this.setState({
              modelActiveRecord: activeRecord,
            });
          },
        });
      }
    );
  };

  viewInferences = () => {
    this.props.storeModelDetails(this.state.modelActiveRecord);
    this.props.history.push('/model-list/modelId/runtime-history');
  };

  handleRecordClick = (record) => {
    this.setState({
      modelActiveRecord: record,
    });
  };

  render() {
    const { models, history } = this.props;
    const { clientHeight, modelActiveRecord } = this.state;
    const { Search } = Input;
    const permissions = {
      showActions: false,
    };
    const modelList = models && models.list;
    const totalRecords = models && models.totalRecords;
    return (
      <>
        <div className={styles.content}>
          <div className={styles.contentWrapper}>
            <div className={styles.tableWrapper} id="tableContainer">
              <div className={styles.optionsContainer}>
                <Search
                  prefix={
                    <Icon
                      onClick={() => {
                        if (document.getElementById('searchInputId')) {
                          document.getElementById('searchInputId').focus();
                        }
                      }}
                      component={() => (
                        <img
                          alt="Search Icon"
                          src={search}
                          style={{
                            height: '20px',
                          }}
                        />
                      )}
                    />
                  }
                  placeholder="Search models"
                  id="searchInputId"
                  onChange={this.handleSearch}
                  className={styles.searchInputBox}
                />
              </div>
              <div className={styles.tableContainer}>
                <TableView
                  clientHeight={clientHeight - 220}
                  columnNames={modelColumns}
                  totalRecords={totalRecords}
                  data={modelList}
                  fetchRecords={this.handlePageChange}
                  activeRecord={modelActiveRecord}
                  onRecordClick={this.handleRecordClick}
                  classNames={{
                    tableStyles: styles.modelsTable,
                  }}
                  permissions={permissions}
                  tableType="model"
                />
              </div>
            </div>
            <div
              style={{
                marginLeft: modelList && modelList.length ? '-10px' : '10px',
              }}
              className={styles.activeItemWrapper}
            >
              {modelActiveRecord && (
                <ModelActiveComponent
                  history={history}
                  modelActiveRecord={modelActiveRecord}
                  archive
                  unArchive={this.unArchiveModel}
                  inferenceList={this.viewInferences}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      models: state.modelArchiveReducer && state.modelArchiveReducer.models,
    }),
    {
      fetchArchiveModels,
      modelUnarchive,
      storeModelDetails,
    }
  )(ModelArchive)
);
